import React from 'react'
import GlgTabs from 'SharedComponents/glg_tabs'
import ComponentsContainer from './ComponentsContainer'
import PropTypes from 'prop-types'
import HubPage from './club/HubPage'

const DirectorySetupRoot = ({customerId, hubId, roleType, renderTab, isSuperCustomer, strongFilters, allClubs, selectedClubs, availableSeasons, availableCategories, allCustomerManagers, selectedManagers, isProd, eventTagsCategories, eventTagsOptions, timeFormat}) => {
  return (
    <div className='golf-hub-setup-root'>
      {
        renderTab === 'hub_index' ? 
          <GlgTabs>
            <div label={window.I18n.t('views.golfhub.my_hubs')}>
              <ComponentsContainer customerId={customerId} hubId={hubId} roleType={roleType} tab={renderTab} timeFormat={timeFormat}/>
            </div>
            <span className='spacer'></span>
            <div label={window.I18n.t('views.golfhub.editable.banners')}>
              <ComponentsContainer customerId={customerId} tab={'banners'} timeFormat={timeFormat}/>
            </div>
            <div label={window.I18n.t('views.golfhub.editable.sponsors')}>
              <ComponentsContainer customerId={customerId} tab={'sponsors'} timeFormat={timeFormat}/>
            </div>
            <div label={window.I18n.t('views.golfhub.editable.schedules')}>
              <ComponentsContainer customerId={customerId} tab={'schedules'} timeFormat={timeFormat}/>
            </div>
            <span className='spacer'></span>
            <div label={window.I18n.t('views.golfhub.editable.settings')}>
              <ComponentsContainer customerId={customerId} tab={'settings'} timeFormat={timeFormat}/>
            </div>
          </GlgTabs>
          : <div>
              <HubPage
                customerId={customerId}
                roleType={roleType}
                hubId={hubId}
                isSuperCustomer={isSuperCustomer}
                strongFilters={strongFilters}
                allClubs={allClubs}
                selectedClubs={selectedClubs}
                availableSeasons={availableSeasons}
                availableCategories={availableCategories}
                allCustomerManagers={allCustomerManagers}
                selectedManagers={selectedManagers}
                isProd={isProd}
                eventTagsCategories={eventTagsCategories}
                eventTagsOptions={eventTagsOptions}
              />
            </div>
      }
    </div>
  )
}

DirectorySetupRoot.propTypes = {
  customerId: PropTypes.string,
  hubId: PropTypes.string,
  roleType: PropTypes.string,
  renderTab: PropTypes.string,
  isSuperCustomer: PropTypes.string,
  allClubs: PropTypes.array,
  selectedClubs: PropTypes.array,
  strongFilters: PropTypes.array,
  availableSeasons: PropTypes.array,
  availableCategories: PropTypes.array,
  allCustomerManagers: PropTypes.array,
  selectedManagers: PropTypes.array,
  isProd: PropTypes.bool,
  eventTagsCategories: PropTypes.object,
  eventTagsOptions: PropTypes.object,
  timeFormat: PropTypes.string,
}


export default DirectorySetupRoot
